import '../../css/rules.css';
import { observer } from 'mobx-react-lite';
import BackButton from '../components/BackButton';
import HeaderLogo from '../components/HeaderLogo';
import State from '../data/State';

export default observer(() => {
  return (
    <div className='rules-block'>
      <BackButton callback={() => State.toBackScreen()} />
      <HeaderLogo />
      <div className='rules-header'>ПРАВИЛА</div>
      <div className='rules-header-content'>Здесь мы подробно рассказываем о том, как получить подарки от Santo Stefano.<br /><br />Перейдите по ссылке и ознакомьтесь с <a href='/docs/pravila_akcii_main.pdf' target='_blank'>общими правилами акции</a>.</div>
      {/*<div className='rules-header-content'><a href='/docs/pravila_akcii_prazdnik_puzirki.pdf' target='_blank'>Правила акции «ПРАЗДНИК. ПУЗЫРЬКИ. ПОДАРКИ ОТ SANTO STEFANO»</a></div>
      <div className='rules-header-content'><a href='/docs/pravila_akcii_more_vpechatlenii.pdf' target='_blank'>Правила акции «МОРЕ ВПЕЧАТЛЕНИЙ»</a></div>*/}
      <div className='rules-tabbar-indent'></div>
      <div className='rules-blur'></div>
    </div>
  );
});